class CapacityHomeController {
    constructor(toastr, $routeParams, CapacityServiceApi, TraceHubExService, moment, UserDetailsApi, $rootScope, SettingsService) {
        this.traceHubComponentName = 'capacity-home';
        // How many nodes should be shown on the charts at any one time. After this limit is reached it's one in, one out.
        this.runTimeHistoryDataPoints = 30;
        this.$onInit = () => {
            this.init();
        };
        this.$onDestroy = () => {
            this.TraceHubExService.stop(this.traceHubComponentName);
        };
        this.init = () => {
            this.transactionsPerSecond = 0;
            this.transactionCount = 0;
            this.pendingTransactions = 0;
            this.timedOutTransactions = 0;
            this.state = {
                simulatorLoading: true,
                tpsUpdating: false,
                readOnly: false,
                targetTPS: 0,
                targetTPSInput: 0,
                sliderOptions: null,
                taskTraces: [],
                tpsOptions: {
                    range: {
                        left: [0, 0]
                    }
                },
                responseTimeOptions: {
                    range: {
                        left: [0, 0]
                    }
                },
                isUIHidden: false
            };
            try {
                this.userId = parseInt(this.$routeParams.userId, 10);
                this.simulatorId = parseInt(this.$routeParams.simId, 10);
            }
            catch (_a) {
                this.toastr.warning('Problem getting tester ID and/or simulator ID');
                return;
            }
            this.UserDetailsApi.get().then((response) => {
                let connectedUser = response.data;
                this.userDetails = connectedUser;
                this.clearAllStats();
                this.getCapacitySim();
            });
            this.initSignalR();
            this.$rootScope.$on('$visibilitychange', (event, isHidden) => {
                this.state.isUIHidden = isHidden;
            });
        };
        this.getConnectionStatusAsString = () => {
            let status = this.capacitySimDto.Status ? this.capacitySimDto.Status : 'Stopped';
            if (!this.capacitySimDto.Connected && status !== 'Stopped') {
                status += ' (Not Connected)';
            }
            return status;
        };
        this.getCapacitySim = () => {
            this.state.simulatorLoading = true;
            this.CapacityServiceApi.
                getCapacitySimulatorInstanceDto(this.userId, this.simulatorId).
                then((response) => {
                this.capacitySimDto = response.data;
                if (!_.isNil(this.capacitySimDto) && !_.isEmpty(this.capacitySimDto)) {
                    this.state.sliderOptions = {
                        minLimit: 0,
                        floor: 0,
                        ceil: this.capacitySimDto.MaximumTPS,
                        showSelectionBar: true,
                        showTicks: this.capacitySimDto.MaximumTPS / 10,
                        ticksTooltip: (value) => {
                            return value;
                        },
                        onChange: (sliderId, modelValue, highValue, pointerType) => {
                            this.state.targetTPSInput = modelValue;
                        }
                    };
                    if (this.capacitySimDto.Status === 'Error') {
                        this.state.taskTraces.push({
                            Level: TaskTraceLevel.Error,
                            TimeStamp: !_.isNil(this.capacitySimDto.Stopped) ? this.capacitySimDto.Stopped : this.moment.utc().toDate(),
                            Title: this.capacitySimDto.Status,
                            Message: this.capacitySimDto.StatusDescription,
                            DetailedMessage: ''
                        });
                    }
                    if (this.state.targetTPS !== this.capacitySimDto.TargetTPS) {
                        this.updateClientTargetTPS(this.capacitySimDto.TargetTPS);
                    }
                    if (this.capacitySimDto.IdPId && this.capacitySimDto.IdPId !== this.userDetails.SingleSignOnDetails.IdPID) {
                        this.state.readOnly = true;
                        this.state.sliderOptions.readOnly = true;
                        this.state.taskTraces.push({
                            Level: TaskTraceLevel.Warning,
                            TimeStamp: this.moment.utc().toDate(),
                            Title: 'Read Only',
                            Message: 'This simulator is being controlled by another user',
                            DetailedMessage: ''
                        });
                    }
                    this.CapacityServiceApi.getSessionHistory(this.capacitySimDto.SessionId, this.runTimeHistoryDataPoints).
                        then((historyResponse) => {
                        let history = historyResponse.data;
                        for (let stat of history) {
                            let localTimeInUnix = this.moment.utc(stat.Timestamp.toString()).local().unix();
                            this.tpsChartLayers[0].values.push({
                                time: localTimeInUnix,
                                y: stat.TPS
                            });
                            this.responseTimeChartLayers[0].values.push({
                                time: localTimeInUnix,
                                y: stat.MedianResponseTime
                            });
                            this.updateMaximumYAxisValue(stat.TPS, stat.MedianResponseTime);
                        }
                        // Chart library requires the array be populated before it is rendered
                        this.state.simulatorLoading = false;
                        if (!_.isNil(history) && history.length > 0) {
                            this.addNewRunningStat(history[0], false);
                        }
                    });
                }
                else {
                    this.updateClientTargetTPS(0); // To avoid any NaN issues
                    this.state.taskTraces.push({
                        Level: TaskTraceLevel.Error,
                        TimeStamp: this.moment.utc().toDate(),
                        Title: 'No Simulator Found',
                        Message: 'Cannot find a running stress simulator',
                        DetailedMessage: ''
                    });
                    this.clearAllStats();
                    this.state.simulatorLoading = false;
                    this.state.sliderOptions = {
                        disabled: true
                    };
                }
            });
        };
        this.initSignalR = () => {
            this.SettingsService.getSettings().then((response) => {
                const appSettings = response.data;
                this.TraceHubExService.connectWithSpecificTransport(this.traceHubComponentName, appSettings.SignalRTransport);
                this.TraceHubExService.on(this.traceHubComponentName, 'onInit', (connId) => {
                    this.connectionId = connId;
                });
                this.TraceHubExService.on(this.traceHubComponentName, 'onNewCapacityRunningStat', (e) => {
                    if (e.ConnectionId !== this.connectionId) {
                        return;
                    }
                    this.addNewRunningStat(e.CapacityRunningStat, true);
                });
                this.TraceHubExService.on(this.traceHubComponentName, 'onCapacityUIUpdate', (e) => {
                    if (e.ConnectionId !== this.connectionId) {
                        return;
                    }
                    if (this.state.targetTPS !== e.TargetTPS) {
                        this.updateClientTargetTPS(e.TargetTPS);
                    }
                });
                this.TraceHubExService.on(this.traceHubComponentName, 'onNewCapacityTaskTraces', (e) => {
                    if (e.ConnectionId !== this.connectionId) {
                        return;
                    }
                    this.state.taskTraces.push(...e.TaskTraces);
                });
                this.TraceHubExService.on(this.traceHubComponentName, 'onCapacitySimInstanceChange', (e) => {
                    if (e.ConnectionId !== this.connectionId) {
                        return;
                    }
                    this.capacitySimDto = e.CapacitySim;
                });
                // Subscribe to this so we can handle if someone else has started or stopped the sim while we are still on this page
                this.TraceHubExService.on(this.traceHubComponentName, 'onSimStatusChange', (args) => {
                    if (args.UserId !== this.userId || args.SimId !== this.simulatorId) {
                        return;
                    }
                    this.removeAllTaskTraces();
                    if (!_.isNil(args.ErrorMessage)) {
                        this.state.taskTraces.push({
                            Level: TaskTraceLevel.Error,
                            TimeStamp: this.moment.utc().toDate(),
                            Title: 'Simulator Error',
                            Message: args.ErrorMessage,
                            DetailedMessage: ''
                        });
                    }
                    this.getCapacitySim();
                });
                this.TraceHubExService.on(this.traceHubComponentName, 'onCapacitySessionCleared', (e) => {
                    if (e.ConnectionId !== this.connectionId) {
                        return;
                    }
                    this.clearAllStats();
                });
            });
        };
        this.onTpsTextChange = () => {
            // This whole mechanism is to allow the input[number] to be empty without the slider showing 'NaN' or 'undefined'.
            // It allows us to do the validation on the manually inputted text before updating variable the slider uses.
            if (_.isNil(this.state.targetTPSInput) || !_.isNumber(this.state.targetTPSInput)) {
                return;
            }
            if (this.state.targetTPSInput < this.state.sliderOptions.minLimit) {
                this.state.targetTPSInput = this.state.sliderOptions.minLimit;
            }
            else if (this.state.targetTPSInput > this.state.sliderOptions.ceil) {
                this.state.targetTPSInput = this.state.sliderOptions.ceil;
            }
            this.state.targetTPS = this.state.targetTPSInput;
        };
        this.updateClientTargetTPS = (targetTPS) => {
            this.state.targetTPS = targetTPS;
            this.state.targetTPSInput = targetTPS;
        };
        this.updateServerTargetTPS = () => {
            this.state.tpsUpdating = true;
            // Slider needs to be disabled manually like this.
            // Would rather use this.state.tpsUpdating but it doesn't support ng-disabled unfortunately.
            this.state.sliderOptions.disabled = true;
            this.CapacityServiceApi.updateTargetTPS(this.capacitySimDto.SessionId, this.state.targetTPS).
                then((response) => {
                this.capacitySimDto.TargetTPS = response.data;
                this.state.tpsUpdating = false;
                this.state.sliderOptions.disabled = false;
            });
        };
        this.removeAllTaskTraces = () => {
            this.state.taskTraces = [];
        };
        this.removeTaskTrace = (taskTrace) => {
            _.remove(this.state.taskTraces, tt => tt === taskTrace);
        };
        this.addNewRunningStat = (stat, addToChart) => {
            // If the UI is not visible don't bother adding the stat as it will just cause a UI backlog when
            // the page gets focus again. This does mean we essentially "skip" these stats and the charts will
            // potentially have massives time gaps but it keepsthem real-time
            if (this.state.isUIHidden) {
                return;
            }
            this.transactionsPerSecond = stat.TPS;
            this.transactionCount = stat.TransactionCount;
            this.pendingTransactions = stat.PendingCount;
            this.timedOutTransactions = stat.TimedOutCount;
            this.updateMaximumYAxisValue(this.transactionsPerSecond, stat.MedianResponseTime);
            // If simulatorLoading is true then the chart might not be shown yet so we need to wait for that
            if (addToChart && !this.state.simulatorLoading) {
                let localTimeInUnix = this.moment.utc(stat.Timestamp.toString()).local().unix();
                this.tpsChartStream = [{
                        time: localTimeInUnix,
                        y: this.transactionsPerSecond
                    }];
                this.responseTimeChartStream = [{
                        time: localTimeInUnix,
                        y: stat.MedianResponseTime
                    }];
            }
        };
        this.updateMaximumYAxisValue = (tps, responseTime) => {
            // Force 0 to always be displayed but update the highest value to allow a partially dynamic range
            if (tps > this.state.tpsOptions.range.left[1]) {
                this.state.tpsOptions.range.left[1] = tps;
            }
            if (responseTime > this.state.responseTimeOptions.range.left[1]) {
                this.state.responseTimeOptions.range.left[1] = responseTime;
            }
        };
        this.clearAllStats = () => {
            this.transactionsPerSecond = 0;
            this.transactionCount = 0;
            this.pendingTransactions = 0;
            this.timedOutTransactions = 0;
            this.tpsChartStream = undefined;
            this.tpsChartLayers = [{
                    label: 'Transactions Per Second',
                    values: []
                }];
            this.responseTimeChartStream = undefined;
            this.responseTimeChartLayers = [{
                    label: 'Response Time',
                    values: []
                }];
        };
        this.toastr = toastr;
        this.$routeParams = $routeParams;
        this.CapacityServiceApi = CapacityServiceApi;
        this.TraceHubExService = TraceHubExService;
        this.moment = moment;
        this.UserDetailsApi = UserDetailsApi;
        this.$rootScope = $rootScope;
        this.SettingsService = SettingsService;
    }
}
angular.module('app').component('capacityHome', {
    bindings: {},
    controllerAs: 'vm',
    controller: CapacityHomeController,
    templateUrl: 'scripts/app/partials/Capacity/capacity-home.tpl.html'
});
